import { useData, useList } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { Counts } from "../types"

export function useCounts(
  params: // accept also list of ids
  Record<string, string | number | Array<number>> = {},
  enabled = true
) {
  return useData<Counts>(`${API_URL}/admin/counts`, {
    query: params,
    reactQuery: {
      enabled: enabled,
      queryKey: ["counts", params],
    },
  })
}